export default {
  hero: {
    title: '成功事例紹介',
    subtitle: 'グローバル企業の複雑なビジネス課題を解決し、デジタルトランスフォーメーションと成長を実現した事例をご紹介します',
    imageAlt: '事例紹介背景画像'
  },
  filter: {
    title: '二次元ケースフィルタリング',
    regionTitle: '地域でフィルタリング',
    industryTitle: '業界でフィルタリング',
    currentFilter: '現在のフィルター',
    clearAll: 'すべてクリア',
    regions: {
      all: 'すべての地域',
      china: '中国本土',
      hongkong: '中国香港',
      taiwan: '中国台湾',
      japan: '日本',
      korea: '韓国',
      singapore: 'シンガポール',
      america: 'アメリカ大陸',
      europe: 'ヨーロッパ'
    },
    industries: {
      all: 'すべての業界',
      manufacturing: '製造業',
      finance: '金融',
      healthcare: '医療・ヘルスケア',
      retail: '小売・EC',
      government: '政府・公共サービス',
      professional: 'プロフェッショナルサービス'
    }
  },
  caseList: {
    resultCount: 'フィルター結果',
    projectBackground: 'プロジェクト背景',
    implementation: '実施内容',
    loadMore: '事例をもっと見る',
    loading: '読み込み中...',
    noMore: 'これ以上事例はありません'
  },
  cases: {
    case1: {
      regionLabel: '日本',
      industryLabel: '製造業',
      title: '日本製造企業ハイブリッドクラウド移行',
      background: '従業員12,000人を擁する日本の大手自動車部品メーカー。中国、タイ、米国に生産拠点を持つ。地域間のデータ同期遅延、システムメンテナンスコストの高さ、事業継続性の不足などの課題に直面し、効率的で安全なハイブリッドクラウドアーキテクチャの構築が必要でした。',
      implementation: [
        '日中両国にまたがるハイブリッドクラウドアーキテクチャの設計と実装',
        '基幹業務システムのAWSクラウドプラットフォームへの移行',
        '分散データ同期とディザスタリカバリシステムの構築',
        'ネットワークアーキテクチャの再構築とグローバル高速化の最適化',
        '7×24時間グローバル運用サポート体制の構築'
      ],
      metrics: [
        { value: '40%', label: 'システム応答速度向上' },
        { value: '25%', label: '運用コスト削減' },
        { value: '100%', label: 'コンプライアンス合格率' }
      ]
    },
    case2: {
      regionLabel: 'シンガポール',
      industryLabel: '金融',
      title: 'シンガポールフィンテック企業データセキュリティアップグレード',
      background: 'シンガポールの大手決済サービスプロバイダー。1日あたり500万件以上の取引を処理し、年間取引額は150億シンガポールドルに達します。MAS（シンガポール金融管理局）の規制要件の厳格化、データ漏洩リスク、国際間決済セキュリティなどの課題に直面し、国際基準に準拠した多層データセキュリティ防護システムの構築が必要でした。',
      implementation: [
        'エンドツーエンドデータ暗号化システムの導入（AES-256標準）',
        '多要素認証とアクセス制御システム',
        'リアルタイム脅威検知とセキュリティインシデント対応プラットフォーム',
        'MASコンプライアンス監査準備と文書化',
        'DDoS防護とAPIセキュリティ強化',
        'データバックアップとディザスタリカバリソリューションの実装'
      ],
      metrics: [
        { value: '95%', label: 'セキュリティインシデント削減' },
        { value: '100%', label: 'MASコンプライアンス監査合格' },
        { value: '60%', label: '脅威対応時間短縮' }
      ]
    },
    case3: {
      regionLabel: '韓国',
      industryLabel: '医療・ヘルスケア',
      title: '韓国医療機関AI診断支援プラットフォーム',
      background: 'ソウルの大型総合病院。1,200床を有し、年間診療件数は80万件を超えます。画像診断医の不足、診断精度への人的要因の影響、患者の待機時間の長さなどの課題に直面し、AI技術を導入して診断効率と精度を向上させる必要がありました。',
      implementation: [
        'AI画像解析システムの導入とカスタマイズトレーニング',
        '医療画像データのアノテーションとディープラーニングモデルの最適化',
        '既存PACSシステムとの統合とデータインターフェース開発',
        '医師向けトレーニングとAI診断支援ワークフローの設計',
        '診断品質管理とAIシステムの継続的最適化メカニズムの確立'
      ],
      metrics: [
        { value: '35%', label: '診断精度向上' },
        { value: '70%', label: '画像処理時間短縮' },
        { value: '42%', label: '患者満足度向上' }
      ]
    },
    case4: {
      regionLabel: '中国香港',
      industryLabel: '小売・EC',
      title: '香港小売グループ オムニチャネル会員・在庫プラットフォーム',
      background: '実店舗、EC、会員制度を運営する香港の小売チェーンは、チャネル間在庫の不一致、注文履行の可視性不足、会員データの分断、リピート施策の効果測定不足に直面していました。そこで、統合されたオムニチャネル小売運営基盤が必要となりました。',
      implementation: [
        '商品、在庫、注文、会員マスターデータを統合するオムニチャネル中台を構築',
        '店舗、EC、キャンペーン、会員データを統合する顧客データ基盤を導入',
        'クラウド POS、モバイル決済、店舗 CRM を連携し、現場運営を改善',
        '倉庫から店舗までの可視化ダッシュボードを整備し、補充と移送判断を最適化',
        '精密マーケティングとレコメンド連携により、ロイヤルティ施策を強化'
      ],
      metrics: [
        { value: '32%', label: '在庫精度向上' },
        { value: '28%', label: '再購入率向上' },
        { value: '41%', label: '欠品率低下' }
      ]
    },
    case5: {
      regionLabel: '中国本土',
      industryLabel: 'プロフェッショナルサービス',
      title: '華東コンサルティング企業セキュアナレッジワークスペース',
      background: '複数都市にデリバリーチームを持つコンサルティング企業は、文書バージョンの分散、顧客資料の権限制御の複雑さ、工数入力の遅れ、頻繁なリモート協業に課題を抱えていました。安全な協業、請求管理、ナレッジ蓄積を兼ねる統合ワークスペースが求められていました。',
      implementation: [
        '細かな権限管理と監査証跡を備えた安全な文書管理基盤を導入',
        '企業向け会議・統合コミュニケーションを連携し、遠隔協業を支援',
        '工数管理、プロジェクト管理、請求システムを統合して請求可能工数取得を改善',
        '顧客オンボーディング、契約レビュー、承認フローをデジタルで自動化',
        'ナレッジタグと事例アーカイブを整備し、再利用可能な知見を蓄積'
      ],
      metrics: [
        { value: '68%', label: '文書検索速度向上' },
        { value: '22%', label: '請求可能工数取得率向上' },
        { value: '45%', label: '顧客オンボーディング期間短縮' }
      ]
    }
  },
  consultation: {
    title: '貴社に最適なソリューションをお探しですか？',
    description: '業界や所在地を問わず、デジタルトランスフォーメーションのカスタマイズソリューションを提供いたします。無料相談をご利用ください！',
    button: '無料相談を申し込む'
  }
}
